var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1251 8.83332V24.2917H11.4172L8.83341 26.8754V8.83332H33.1251ZM35.3334 4.41666H6.62508C5.4105 4.41666 4.41675 5.41041 4.41675 6.62499V37.5417L13.2501 28.7083H35.3334C36.548 28.7083 37.5417 27.7146 37.5417 26.5V6.62499C37.5417 5.41041 36.548 4.41666 35.3334 4.41666ZM46.3751 13.25H41.9584V33.125H13.2501V37.5417C13.2501 38.7562 14.2438 39.75 15.4584 39.75H39.7501L48.5834 48.5833V15.4583C48.5834 14.2437 47.5897 13.25 46.3751 13.25Z",
    fill: "#009CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerIcon);
export default __webpack_public_path__ + "static/media/answer-icon.3af47ab3e97530233d40a8dbc90e7b90.svg";
export { ForwardRef as ReactComponent };